// @styles
require('./aggregatorSecondKeyAuthModal.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @components
const OKModal = require('components/commons/OKModal/OKModal');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @utilities
const { FormattedText } = require('core/i18n').i18n;
import { recordLink, PROC_AGGREGATOR, PROC_OTP_MODAL_CLOSE } from 'utilities/tagging';

class AggregatorSecondKeyAuthModal extends React.Component {

    handleRequestSendingNewOtp = () => {
        const { requestSendingNewOtp, onCloseCallback } = this.props;

        requestSendingNewOtp()
        onCloseCallback()
    }
    
    handleCloseModal = () => {
        const { onCloseCallback } = this.props;
        
        recordLink(PROC_AGGREGATOR, PROC_OTP_MODAL_CLOSE)
        onCloseCallback()
    }

    buildContent = () => {
        const { showKeyModal } = this.props;

        return (
            <OKModal
                isOpen={showKeyModal}
                onCloseCallback={this.handleCloseModal}
                content={
                    <div>
                        <p><FormattedText value="secondKeyModal-firstParagraphDescription" /></p>
                        <p><FormattedText value="secondKeyModal-secondParagraphDescription"/></p>
                        <p><FormattedText value="secondKeyModal-thirdParagraphDescription" /></p>
                    </div>
                }
                title={
                    <FormattedText value="secondKeyModal-title" />
                }
                contentFooter={
                    <div className="aggregator-modal-second-key-success-footer ">
                        <OKButton onClick={this.handleRequestSendingNewOtp}>
                            <FormattedText value="aggregatorStatus-expiredKeyButton" />
                        </OKButton>
                    </div>
                }
            />
        )
    }

    render() {
        return (
            this.buildContent()
        )
    }
}

AggregatorSecondKeyAuthModal.propTypes = {
    showKeyModal: PropTypes.bool,
    userBankId: PropTypes.string,
    requestSendingNewOtp: PropTypes.func,
    onCloseCallback: PropTypes.func,
}

export { AggregatorSecondKeyAuthModal }